import constants from '../constants/init';

const setActState = props => {
  let actState;
  const time = window.__CUTTLE_SERVER_INFO__.timestamp;
  switch (true) {
    case time >= (new Date(props.end)).getTime(): {
      actState = 0;
      break;
    }
    default : {
      actState = 1;
    }
  }
  return actState;
};

// 初始化
export const init = conf => {
  return {
    type: constants.QUERY,
    data: {
      conf,
      actState: setActState(conf),
    },
  };
};
